import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import MaterialTable from "../../components/Table/MaterialTable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const BookingInventoryPools = () => {
  const [inventoryPools, setInventoryPools] = useState([]);
  const [hotelMap, setHotelMap] = useState({});

  const columns = [
    { field: "hotel_name", title: "Hotel", editable: "never" },
    {
      field: "booking_date",
      title: "Booking Date",
      type: "date",
      editable: "never",
    },
    {
      field: "room_type_id",
      title: "Room Type ID",
      type: "number",
      editable: "never",
    },
    {
      field: "numberof_rooms",
      title: "Total Rooms",
      type: "number",
      editable: "never",
    },
    {
      field: "rooms_available_count",
      title: "Available Rooms",
      type: "number",
      editable: "never",
    },
    {
      field: "room_booked_count",
      title: "Booked Rooms",
      type: "number",
      editable: "never",
    },
    {
      field: "last_updated",
      title: "Last Updated",
      type: "datetime",
      editable: "never",
    },
  ];

  useEffect(() => {
    const fetchInventoryPoolsAndHotels = async () => {
      try {
        // Fetch hotel data
        const hotelRes = await fetch("https://api.esthell.com/Hotel");
        const hotelData = await hotelRes.json();

        const hotelMapData = {};
        if (hotelData.success && Array.isArray(hotelData.data)) {
          hotelData.data.forEach((hotel) => {
            hotelMapData[hotel.hotel_id] = hotel.name;
          });
        }

        setHotelMap(hotelMapData);

        // Fetch inventory pool data
        const inventoryRes = await fetch(
          "https://api.esthell.com/BookingInventoryPools",
        );
        const inventoryData = await inventoryRes.json();

        if (inventoryData.success && Array.isArray(inventoryData.data)) {
          const updatedData = inventoryData.data.map((item) => ({
            ...item,
            hotel_name: hotelMapData[item.hotel_id] || item.hotel_id,
          }));
          setInventoryPools(updatedData);
        }
      } catch (error) {
        console.error("Error fetching inventory pools:", error);
      }
    };

    fetchInventoryPoolsAndHotels();
  }, []);
  const handleExport = () => {
    const exportData = inventoryPools.map((row) => ({
      Hotel: row.hotel_name,
      "Booking Date": row.booking_date,
      "Room Type ID": row.room_type_id,
      "Total Rooms": row.numberof_rooms,
      "Available Rooms": row.rooms_available_count,
      "Booked Rooms": row.room_booked_count,
      "Last Updated": row.last_updated,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inventory");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(
      dataBlob,
      `BookingInventoryPools_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
  };
  return (
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h4"
        sx={{ mb: 3, color: "#1a237e", fontWeight: "bold" }}
      >
        Booking Inventory Pools
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Button variant="contained" color="primary" onClick={handleExport}>
          Export to Excel
        </Button>
      </Box>
      <MaterialTable
        columns={columns}
        data={inventoryPools}
        printTitle="Booking Inventory Pools"
        enableRowActions={false}
        options={{
          search: false,
          paging: true,
          filtering: false,
          sorting: true,
          actionsColumnIndex: -1,
          editable: false,
        }}
      />
    </Box>
  );
};

export default BookingInventoryPools;
